$(document).ready(function () {
  $.modal.defaults.closeText = '';
  $.modal.defaults.closeExisting = false;
  $('select').niceSelect();
  var mediaQuery = window.matchMedia('(max-width: 768px)');
  setResponsiveDesign(mediaQuery);
  mediaQuery.addListener(function (mqe) {
    setResponsiveDesign(mqe)
  });

  $('.icon-cards').slick({
    slidesToShow: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 8000,
        settings: "unslick"
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        }
      },
    ]
  });

  $('.reviews').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        }
      }
    ]
  });

  function setResponsiveDesign(mqe) {
    resetSlicks();
    if (mqe.matches) useMobileDesign();
    else useDesktopDesign();
  }

  function useDesktopDesign() {
    $('.you-item__carousel').slick({
      slidesToShow: 1,
      arrows: true,
      dots: false,
      fade: true,
      swipe: false,
      prevArrow: $('.you__nav-arrows--prev'),
      nextArrow: $('.you__nav-arrows--next'),
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 500,
    });

    $('.you-item__reviews').each(function (key, item) {
      $(this).slick({
        slidesToShow: 1,
        arrows: (window.innerWidth > 768),
        responsive: [
          {
            breakpoint: 8000,
            settings: "unslick"
          }
        ]
      });
    });

    $('.links-list__inner-item').each(function (ind, el) {
      var id = 'items-link-' + ind;
      $(this).find('.links-tooltip').removeAttr('id');
      $(this).find('.links-list__inner-item-link')
        .removeAttr('href')
        .removeAttr('rel');
    });
  }

  function useMobileDesign() {
    $('.you-item__carousel--mobile').slick({
      slidesToShow: 1,
      arrows: false,
      dots: true,
      fade: true,
      swipe: true,
      // adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 500,
    });

    $('.links-list').slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
    });

    // Responsive links
    $('.links-list__inner-item').each(function (ind, el) {
      var id = 'items-link-' + ind;
      $(this).find('.links-tooltip').attr('id', id);
      $(this).find('.links-list__inner-item-link')
        .attr('href', '#' + id)
        .attr('rel', 'modal:open');
    });
  }

  function resetSlicks() {
    $('.l-links').find('.slick-initialized').slick('unslick');
    $('.l-you').find('.slick-initialized').slick('unslick');
  }

  $('.popular-service').slick({
    slidesToShow: 1,
    arrows: false,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
  });

  new window.WOW().init();

  // For step form can't use jquery validation since we can't get back on steps !!!
  var stepFormError = $('.step-form-error');
  function setStepFormError(message) {
    stepFormError.text(message).show();
  }
  function resetStepFormError() {
    stepFormError.hide();
  }

  $('.form-step--1 > .form-step__btn').click(function () {
    $(this).parent().removeClass('form-step--active');
    $('.form-step--2').addClass('form-step--active');
  });

  $('.form-step--2 > .form-step__btn').click(function () {
    var title = $('.form-step--2 .input-text').val();
    if (!title.length) return setStepFormError('This field is required.');
    resetStepFormError();
    $(this).parent().removeClass('form-step--active');
    $('.form-step--3').addClass('form-step--active');
  });

  $('.form-step--3 > .form-step__btn').click(function (e) {
    e.preventDefault();
    var email = $('.form-step--3 .input-text').val();
    if (!email.length) return setStepFormError('This field is required.');
    if (!/\S+@\S+\.\S+/.test(email)) return setStepFormError('Please enter a valid email address.');
    resetStepFormError();
    $('.form-steps').submit();
    $(this).attr('disabled', true);
  });

  function decorateUrlWithGAtracker(urlString) {
    var ga = window[window['GoogleAnalyticsObject']];
    var tracker;
    try {
      tracker = ga.getAll()[0];
      urlString = (new window.gaplugins.Linker(tracker)).decorate(urlString);
    } catch (error) {
      console.error('GA Error', error);
      return urlString;
    }
    return urlString;
  }

  var shortRegForms = $('#sendUnregordershortform,#sendUnregordershortform-1,#sendUnregordershortform-2,#sendUnregordershortform-3');

  shortRegForms.on('submit', function (e) {
    var actionUrl = $(this).attr('action');
    var newActionUrl = decorateUrlWithGAtracker(actionUrl);
    $(this).attr('action', newActionUrl);
  });
});

// Promocode
$(function () {
  // Promocode
  $('.header__have-promo-link').click(function () {
    $(this).hide();
    $('.header__have-promo-field').addClass('header__have-promo-field--active');
  });

  var promocodeInput = $('#promocode-input');
  var checkPromocodeBtn = $('.header__have-promo-field-btn');
  var wrongPromocode = $('.header__have-promo-field-no');
  var wrongPromocodeText = wrongPromocode.find('.header__have-promo-field-no__text');

  promocodeInput.focus(function () {
    checkPromocodeBtn.show();
    wrongPromocode.hide();
  });

  wrongPromocode.on('click', function () {
    wrongPromocode.hide();
    checkPromocodeBtn.show();
  })

  checkPromocodeBtn.click(function () {
    var promocode = promocodeInput.val();

    if (promocode < 1) {
      checkPromocodeBtn.hide();
      wrongPromocodeText.html($.i18n._('Invalid promo code'));
      wrongPromocode.css('display', 'flex');
    } else {
      $.post(
        '/ajax/checkPromocodeAll',
        { code: promocode }
      ).done(function (data) {
        var status = data.status;
        if (status === 1) {
          $('.header__have-promo-field-yes')
            .val('Success! You get ' + data.sum)
            .css('display', 'flex');
          checkPromocodeBtn.hide();
          promocodeInput.attr('disabled', 'disabled');
          $('[data-js="promocode"]').each(function (ind, el) {
            el.value = promocode;
          });
          $('[data-js="promocodeSum"]').text(data.sum);
        }
        if (status === -1 || status === -2) {
          wrongPromocodeText.html($.i18n._('Invalid promo code'));
          wrongPromocode.css('display', 'flex');
          checkPromocodeBtn.hide();
        }
        if (status === -3) {
          wrongPromocodeText.html($.i18n._('Required field'))
          wrongPromocode.css('display', 'flex');
          checkPromocodeBtn.hide();
        }
      })
    }
  });
})


// Validate authorization forms
$(function () {
  var INVALID_EMAIL_OR_PASSWORD = 2;
  var BLOCKED_ACCOUNT = 3;

  var signupForm = $('#popup-signup');
  var signupPassword = signupForm.find('[type="password"]');
  var signupAgreement = signupForm.find('[type="checkbox"]');
  var signupAgreementBox = signupForm.find('[for="agreement"]');

  var loginForm = $('#popup-login');
  signupAgreement.focus(function (e) {
    signupAgreementBox.removeClass('input-invalid');
  })

  signupPassword.on('change', function (e) {
    $('[data-js="password-repeat"]').val(e.target.value);
  });

  function showError(message) {
    loginForm.find('.popup-login__error')
      .html(message)
      .show();
  }

  function resetError() {
    loginForm.find('.login-error').hide();
  }

  function toOrigin(path) {
    return window.location.origin + path;
  }

  function isFullPath(url) {
    return (/^https?:\/\//i).test(url);
  }
  function loginViaRest(form) {
    resetError();
    var loginData = new FormData(form);
    var cookieRef = $.cookie('pa24') || '';
    if (cookieRef) {
      loginData.append('ref', cookieRef);
    }
    var isMobile = window.location.host.startsWith('m.');
    var postPath = process.env.PROJECT_NAME === 'br'
      ? window.location.origin
        .replace('.com.br', '.app')
        .replace('mystudybay', 'studybay')
      : window.location.origin
        .replace('.com', '.app');
    if (isMobile) postPath = postPath.replace('.m', '');
    postPath += '/auth/domainLogin/';
    fetch(postPath, {
      method: 'POST',
      body: loginData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (response.redirected) {
          window.location.href = response.url;
        } else {
          response.json().then(function (data) {
            var status = response.status;
            if (status >= 200 && status <= 299) {
              // data.redirectUrl is string like "?user=id&token=token"
              window.location.href = toOrigin('/home') + data.redirectUrl;
            } else if (status >= 300 && status <= 399) {
              var redirectPath = data.body.redirectPath;
              window.location.href = isFullPath(redirectPath) ?
                redirectPath :
                toOrigin(redirectPath.startsWith('/') ? redirectPath : '/' + redirectPath);
            } else if (status >= 400 && status <= 499) {
              $(form).find('[type="submit"]').removeAttr('disabled');
              var code = data.error.code;
              if (code === undefined) showError('Page is outdated. Please reload the page');
              else if (code === INVALID_EMAIL_OR_PASSWORD) showError('Wrong email or password');
              else if (code === BLOCKED_ACCOUNT) showError('Account is blocked');
              else if (code === 0 && data.error.status === 418) showError('Wrong email');
            } else if (status >= 500) {
              $(form).find('[type="submit"]').removeAttr('disabled');
              showError('Server is temporary unavailable');
            }
          })
        }
      });
  }

  var validationObject = {
    errorElement: 'div',
    errorClass: 'input-validation-message',
    rules: {
      password: {
        maxlength: 20,
        minlength: 5,
        required: true
      },
      email: {
        required: true,
        email: true,
      }
    },
    messages: {
      password: {
        required: $.i18n._("This field is required"),
        maxlength: $.i18n._("Length must be 5 to 20 symbols"),
        minlength: $.i18n._("Length must be 5 to 20 symbols")
      },
      email: {
        email: $.i18n._("Please enter a valid email address"),
        required: $.i18n._("This field is required")
      }
    },
    highlight: function (element) {
      $(element).removeClass(this.errorClass).addClass('invalid-input');
    },
    unhighlight: function (element) {
      var errorContainer = $(element).parent().find('.input-validation-message');
      errorContainer.removeClass('error');
      $(element).removeClass('invalid-input');
    },
    errorPlacement: function (error, element) {
      $(element).parent().find('.input-error').append(error);
    },
    submitHandler: function (form) {
      $(form).find('[type="submit"]').attr('disabled', true);
      if (form.dataset.form === 'popup-login') {
        loginViaRest(form);
      } else form.submit();
    }
  }

  $('.popup-login form').each(function () {
    $(this).validate(validationObject);
  });
});

// Handle password
$(function () {
  $('.password-field').each(function () {
    var field = $(this).find('[name="password"]');
    var lock = $(this).find('.password-field__lock');

    lock.click(function () {
      if (field.attr('type') === 'password') field.attr('type', 'text');
      else field.attr('type', 'password');
    })
  })
});

// Authorization by social
$(function() {
	var openedWindow = null;
	var onError = null;

	function getDomain() {
		var href = document.location.href;
		if (/test\./.test(href)) return 'https://test.studybay.app';
		if (/dev/.test(href)) return 'https://' + document.location.host.split('.')[0] + '.studybay.local';
		return 'https://studybay.app';
	}

	function parseMessage(event) {
		if (event.data.type !== 'socialAuth') return;
		var status = event.data.payload.status;
		var redirectUrl = event.data.payload.redirect;
		if (status !== undefined) {
			if (openedWindow && openedWindow.close) openedWindow.close();
			switch (status) {
				case 0: {
					if (redirectUrl !== undefined) {
						window.location.assign(redirectUrl);
					} else {
						window.location.assign(getDomain() + '/home/');
					}
					break;
				}
				case 1: {
					if (typeof onError === 'function') {
						onError();
					}
					break;
				}
				default: break;
			}
			window.removeEventListener('message', parseMessage);
			onError = null;
		}
	}

	function authBySocNetwork(name) {
		var openerContext = window.open();
		var socRegId = name === 'facebook' ? '1' : '2';
		var projectName = process.env.PROJECT_NAME === 'br' || 'sb';
		var currentUrl = getDomain();
		var logParams = '/?type_form=' + projectName + '_contentWritingSocAuth_' + socRegId + '&reg_url=' + currentUrl;
		fetch('/auth/getproviderurl/' + name + logParams + '/', {
			method: 'GET',
		})
			.then(function(r){
				return r.json()
			})
			.then(function(data){
				window.addEventListener('message', parseMessage);
				openedWindow = openerContext;
				openerContext.location = data.message;
			});

		return new Promise(function(resolve, reject) {
			onError = reject;
		});
	};

	$('.popup-login__btn-social').each(function() {
		var socialNetwork = $(this).data('social');
		$(this).click(function() {
			authBySocNetwork(socialNetwork)
				.catch(function(error){
					console.log(error)
				});
		})
	});
});

// Handle mobile menu
$(function () {
  var burgerBtn = $('#burger-menu-btn');
  var backdrop = $('#menu-backdrop');
  var mobileMenu = $('#mobile-menu');

  burgerBtn.on('click', function (e) {
    mobileMenu.toggleClass('active');
  });

  backdrop.on('click', function () {
    mobileMenu.removeClass('active');
  })
});

// Validate forms
$(function () {

  $('.form--modern-1').each(function () {
    $(this).validate({
      errorElement: 'div',
      errorClass: 'input-validation-message',
      rules: {
        title: {
          required: true
        },
        type_id: {
          required: true
        },
        email: {
          required: true,
          email: true,
        }
      },
      messages: {
        title: $.i18n._("This field is required."),
        type_id: $.i18n._("This field is required."),
        email: {
          email: $.i18n._("Please enter a valid email address."),
          required: $.i18n._("This field is required.")
        }
      },
      highlight: function (element) {
        $(element).removeClass(this.errorClass).addClass('invalid-input');
      },
      unhighlight: function (element) {
        var errorContainer = $(element).parent().find('.input-validation-message');
        errorContainer.removeClass('error');
        $(element).removeClass('invalid-input');
      },
      errorPlacement: function (error, element) {
        $(element).parent().find('.input-error').append(error);
      },
      submitHandler: function(form) {
        $(form).find('[type="submit"]').attr('disabled', true);
        form.submit();
      }
    });
  });
});

$(function() {
	if (process.env.PROJECT_NAME !== 'br') {
		return;
	}

	document.querySelector('#receive_notifications_signup').addEventListener('change', function(e) {
		e.target.value = e.target.checked ? 1 : 0;
	});
	document.querySelector('#receive_notifications_header').addEventListener('change', function(e) {
		document.querySelector('#sendUnregordershortform-1 input[name="receive_notifications"]').value = e.target.checked ? 1 : 0;
		document.querySelector('#sendUnregordershortform-2 input[name="receive_notifications"]').value = e.target.checked ? 1 : 0;
	});
	document.querySelector('#receive_notifications_l-form').addEventListener('change', function(e) {
		document.querySelector('#sendUnregordershortform-3 input[name="receive_notifications"]').value = e.target.checked ? 1 : 0;
	});
});
